import styled from 'styled-components';
import React, { useMemo } from 'react';
import {
  DropdownInput,
  DropdownInputOption,
} from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';
import { AiInput } from '@/features/editor/widgets/custom-widget/inputs/shared/input-type';

export interface EnumInputProps {
  options: DropdownInputOption[];
  initialValue?: DropdownInputOption;
  onChange?: (value: DropdownInputOption) => void;
}

export function SingleSelectInput({
  options,
  initialValue,
  onChange,
}: EnumInputProps) {
  const longestOption = useMemo(() => {
    if (!options || options.length === 0) return 0;
    return Math.max(...options.map((option) => option.label.length + 5));
  }, [options]);

  return (
    <TopWrapper style={{ width: `${longestOption}ch` }}>
      <DropdownInput
        options={options}
        defaultValue={initialValue}
        onChange={(selected) => {
          if (selected && onChange) {
            onChange(selected as DropdownInputOption);
          }
        }}
        isMulti={false}
        theme={AiInput}
      />
    </TopWrapper>
  );
}

const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 30ch;
  font-family: Inter, sans-serif;

  && * {
    font-family: Inter, sans-serif;
  }
`;
